import _ from 'lodash';

// const deliveryTypesByLanguage = (state) => {
//   let deliveryTypesByLanguage = [];
//   _.forEach(state.deliveryTypes, type=>{
//       _.forEach(type.languages, typeLanguage=>{
//         if(typeLanguage.code=='fr'){
//           deliveryTypesByLanguage.push({id:type.id, name:typeLanguage.delivery_type_language.name});
//         }
//       })
//   })
//   return deliveryTypesByLanguage;
// };



export default {
  // deliveryTypesByLanguage
};
